import type { WavespeedModelConfig } from '../types';
import { clampTo } from '../../tools';

export const ideogramConfigs: Record<string, WavespeedModelConfig> = {
    'ideogram-ai/remove-background': {
        // https://wavespeed.ai/zh-CN/models/ideogram-ai/remove-background
        apiPath: '/ideogram-ai/remove-background',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls } = params;
            return {
                image: image_urls[0],
            };
        },
    },
    'ideogram-ai/ideogram-v4': {
        // https://wavespeed.ai/zh-CN/models/ideogram-ai/ideogram-v4
        apiPath: '/ideogram-ai/ideogram-v4',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'ideogram-ai/ideogram-v4/edit': {
        // https://wavespeed.ai/zh-CN/models/ideogram-ai/ideogram-v4/edit
        apiPath: '/ideogram-ai/ideogram-v4/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, providerOptions } = params;
            return {
                prompt: prompt,
                // 图片 URL
                image: image_urls[0],
                // 可选参数
                strength: typeof providerOptions?.strength === 'number' ? providerOptions.strength : 0.8,
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png'] as const,
                    'jpeg',
                ),
            };
        },
    },
};